// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { ProductType } from '../Instruments/ProductType.js'
import { DirectMessageBase } from './DirectMessageBase.ts'
import { DirectMessageCode } from './DirectMessageCodes.ts'


export let DirectOrderHistoryMessage = function ()
{
    DirectMessageBase.call(this, DirectMessageCode.CODE_ORDER_HISTORY)
    this.FAccount = ''
    this.FBuySell = 0
    this.FOrderNumber = ''
    this.FOrderType = 0
    this.FPrice = 0
    this.FQuantity = 0
    this.FRoute = ''
    this.FRemoteId = ''
    this.FStopLimit = 0
    this.FSymbol = ''
    this.FUTCDateTime = null
    this.FTimeInForce = 0
    this.expDate = null
    this.PutCall = 0
    this.StrikePrice = 0
    this.Status = 0
    this.FLastUpdateTime = null
    this.active = false
    this.boundToOrderId = '-1'
    this.FOrderCreatedByUser = null
    this.FDisClosedQuantity = 0
    this.FFilledQuantity = 0
    this.FRemainingQuantity = 0
    this.eventType = null
    this.ProductType = ProductType.General
    this.externalOrderID = null
    this.externalTradeID = null
}

DirectOrderHistoryMessage.prototype = Object.create(DirectMessageBase.prototype)

Object.defineProperty(DirectOrderHistoryMessage.prototype, 'Account', {
    get: function () { return this.FAccount },
    set: function (val) { this.FAccount = val }
})

Object.defineProperty(DirectOrderHistoryMessage.prototype, 'BuySell', {
    get: function () { return this.FBuySell },
    set: function (val) { this.FBuySell = val }
})

Object.defineProperty(DirectOrderHistoryMessage.prototype, 'OrderNumber', {
    get: function () { return this.FOrderNumber },
    set: function (val) { this.FOrderNumber = val }
})

Object.defineProperty(DirectOrderHistoryMessage.prototype, 'OrderType', {
    get: function () { return this.FOrderType },
    set: function (val) { this.FOrderType = val }
})

Object.defineProperty(DirectOrderHistoryMessage.prototype, 'Price', {
    get: function () { return this.FPrice },
    set: function (val) { this.FPrice = val }
})

Object.defineProperty(DirectOrderHistoryMessage.prototype, 'Quantity', {
    get: function () { return this.FQuantity },
    set: function (val) { this.FQuantity = val }
})

Object.defineProperty(DirectOrderHistoryMessage.prototype, 'Route', {
    get: function () { return this.FRoute },
    set: function (val) { this.FRoute = val }
})

Object.defineProperty(DirectOrderHistoryMessage.prototype, 'RemoteId', {
    get: function () { return this.FRemoteId },
    set: function (val) { this.FRemoteId = val }
})

Object.defineProperty(DirectOrderHistoryMessage.prototype, 'StopLimit', {
    get: function () { return this.FStopLimit },
    set: function (val) { this.FStopLimit = val }
})

Object.defineProperty(DirectOrderHistoryMessage.prototype, 'Symbol', {
    get: function () { return this.FSymbol },
    set: function (val) { this.FSymbol = val }
})

Object.defineProperty(DirectOrderHistoryMessage.prototype, 'UTCDateTime', {
    get: function () { return this.FUTCDateTime },
    set: function (val) { this.FUTCDateTime = val }
})

Object.defineProperty(DirectOrderHistoryMessage.prototype, 'TimeInForce', {
    get: function () { return this.FTimeInForce },
    set: function (val) { this.FTimeInForce = val }
})

Object.defineProperty(DirectOrderHistoryMessage.prototype, 'ExpDate', {
    get: function () { return this.expDate },
    set: function (val) { this.expDate = val }
})

Object.defineProperty(DirectOrderHistoryMessage.prototype, 'LastUpdateTime', {
    get: function () { return this.FLastUpdateTime },
    set: function (val) { this.FLastUpdateTime = val }
})

Object.defineProperty(DirectOrderHistoryMessage.prototype, 'Active', {
    get: function () { return this.active },
    set: function (val) { this.active = val }
})

Object.defineProperty(DirectOrderHistoryMessage.prototype, 'BoundToOrderId', {
    get: function () { return this.boundToOrderId },
    set: function (val) { this.boundToOrderId = val }
})

Object.defineProperty(DirectOrderHistoryMessage.prototype, 'OrderCreatedByUser', {
    get: function () { return this.FOrderCreatedByUser },
    set: function (val) { this.FOrderCreatedByUser = val }
})

Object.defineProperty(DirectOrderHistoryMessage.prototype, 'DisClosedQuantity', {
    get: function () { return this.FDisClosedQuantity },
    set: function (val) { this.FDisClosedQuantity = val }
})

Object.defineProperty(DirectOrderHistoryMessage.prototype, 'FilledQuantity', {
    get: function () { return this.FFilledQuantity },
    set: function (val) { this.FFilledQuantity = val }
})

Object.defineProperty(DirectOrderHistoryMessage.prototype, 'RemainingQuantity', {
    get: function () { return this.FRemainingQuantity },
    set: function (val) { this.FRemainingQuantity = val }
})

Object.defineProperty(DirectOrderHistoryMessage.prototype, 'EventType', {
    get: function () { return this.eventType },
    set: function (val) { this.eventType = val }
})

Object.defineProperty(DirectOrderHistoryMessage.prototype, 'ExternalOrderID', {
    get: function () { return this.externalOrderID },
    set: function (val) { this.externalOrderID = val }
})

Object.defineProperty(DirectOrderHistoryMessage.prototype, 'ExternalTradeID', {
    get: function () { return this.externalTradeID },
    set: function (val) { this.externalTradeID = val }
})